const swedish = {
    STATISTICS: 'Statistik',
    SYSTEM: 'Systemet',
    NEXT: 'next',
    USERNAME: 'Användarnamn',
    PASSWORD: 'Lösenord',
    LOG_IN: 'Logga in',
    LOG_OUT: 'Logga ut',
    LOGIN_FAILED: 'Inloggning misslyckades',
    RESET_PASSWORD_SUCCEEDED: 'Mail skickat!',
    RESET_PASSWORD_FAILED: 'Kunde inte skicka mail',
    FORGOT_PASSWORD: 'Glömt lösenord?',
    NETWORK_ERROR_MESSAGE: 'Det verkar inte gå att ansluta till servern just nu',
    SETTINGS: 'Inställningar',
    CUSTUMER_REPORT: 'Kundrapport',
    COMPANY_REPORT: 'Företagsrapport',
    ANALYSIS: 'Analys',
    LEADS: 'Leads',
    LEADS_PER: 'Leads per',
    LEADS_PER_TYPE: 'Leads per typ',
    SEARCH_WORDS: 'Sökord',
    SEARCHES: 'Sökningar',
    SEARCHES_PER: 'Sökningar per',
    SEARCHES_PER_SEARCH_WORD: 'Sökningar per sökord',
    SEARCH: 'Sök',
    CANCEL: 'Avbryt',
    REPORTS: 'Rapporter',
    SHOW: 'Visa',
    CLEAR: 'Rensa',
    TOTALLY: 'Totalt',
    PERIOD: 'Period',
    VKIID: 'VkiId',
    TYPE_OF_LEAD: 'Typ av Lead',
    PAGE: 'Sida',
    PAGES: 'Sidor',
    LEAD_ORIGIN: 'Lead Origin',
    LEAD_SOURCE: 'Leadkälla',
    SOURCE: 'Källa',
    SOURCES: 'Källor',
    WHAT: 'Vad',
    WHERE: 'Var',
    COUNT: 'Antal',
    TOTAL: 'Total',
    OF: 'Av',
    PER_PAGE: 'Per sida',
    PLACE: 'Plats',
    FROM: 'Från',
    TO: 'Till',
    ALL_PLACES: 'Alla platser',
    GROUP_BY: 'Gruppera',
    DAY: 'Dag',
    WEEK: 'Vecka',
    MONTH: 'Månad',
    ALSO_INCLUDES: 'Inkluderar även',
    LANGUAGE: 'Språk',
    SWEDISH: 'Svenska',
    ENGLISH: 'Engelska',
    CLOSE: 'Stäng',
    YESTERDAY: 'Igår',
    LAST_WEEK: 'Förra veckan',
    LAST_MONTH: 'Förra månaden',
    PAST_YEAR: 'Senaste året',
    PAST_TWO_YEARS: 'Senaste två åren',
    PRODUCT: 'Produkt',
    PRODUCTS: 'Produkter',
    ALL: 'Alla',
    ONLY_CUSTOMERS: 'Bara kunder',
    SHARE: 'Andel',
    CUSTOMER: 'Kund',
    NONCUSTOMER: 'Icke kund',
    COMPANY: 'Företag',
    COMPANIES: 'Företag',
    CITY: 'Stad',
    HID: 'HID, (Vkiid)',
    ORG_NUMBER: 'Organisationsnummer',
    IMPRESSION: 'Exponering',
    IMPRESSIONS: 'Exponeringar',
    IMPRESSIONS_PER: 'Exponeringar per',
    IMPRESSIONS_PER_TYPE: 'Exponeringar per typ',
    CTR: 'CTR',
    KPI: 'Nyckeltal',
    SUMMARY: 'Summering',
    CLICK: 'Klick',
    SELECTED: 'valda',
    CLICK_IN_LIST: 'Klick i listan',
    CTR_IN_LIST: 'CTR i listan',
    IMPRESSION_IN_LIST: 'Exponering i listan',
    IMPRESSION_IN_SUGGEST: 'Exponering i sökförslag',
    IMPRESSION_OF_DETAILPAGE: 'Exponering av detaljsidan',
    SELECT_COMPANIES: 'Välj företag',
    TOOLTIP_SEARCH_COMPANIES: 'Gör om sökningen med valda företag',
    TOOLTIP_HID_INPUT_DISABLED: 'HID sätts automatiskt när företag valts ovan',
    TOOLTIP_HID_INPUT: 'Separera med , (komma) för att söka på flera HID',
    TOOLTIP_ORGNO_INPUT_DISABLED: 'Organisationsnummer kan ej anges i kombination med HID',
    TOOLTIP_ORGNO_INPUT: 'Ange hela orgnummret inklusive inledande 16 för aktiebolag',

    TOOLTIP_DETAIL_EXPOSURE: 'Företagets detaljsidan har visats',
    TOOLTIP_LIST_EXPOSURE: 'Företaget har visats i resultatlistan',
    TOOLTIP_SUGGEST_EXPOSURE: 'Företaget har givits som förslag i sökrutans autocomplete',
    TOOLTIP_MAP_EXPOSURE: 'Företaget har visats vid en sökning i kartan',

    TOOLTIP_PRODUCT_LEAD: {
        'offer-button-company': 'Offertknapp företag',
        grabover: 'Grabover',
        brf_report: 'Brf-rapport',
        facebook: 'Klick på facebook-länk',
        favorit: 'Lagts till som favorit',
        foretagsgruppering: 'Företagsgruppering',
        'grafisk-annons': 'Klick på Displayplacering',
        hemsidelank: 'Klick på hemsidelänk',
        infosida: 'Infosida',
        'infosida-delux': 'Infosida deluxe',
        kopieraadress: 'Adressen har kopierats',
        kopieratelefonnr: 'Telefonnummer har kopierats',
        print: 'Detaljsidan har skrivits ut',
        route: 'Klick på vägbeskrivning',
        share_sms: 'Detaljsidan har delats via SMS',
        show_on_map: 'Klick på Visa på karta',
        streetview: 'Klick på Gatubild',
        telefonnr: 'Klick på Visa nummer eller Samtal i appen',
        'topp4-logo': 'Topplacering',
        'topp4-annons': 'Topp 4 annons',
        visatelefonnr: 'Klick på Visa nummer',
        detail: 'Detalj?',
        email: 'Klick på Skicka epost',
        'email-sent': 'E-post har skickats',
        livstilskartan: 'Livsstilskartan',
        save: 'Sparats som kontakt',
        textlank: 'Klick på Textlänk',
        'logo-listning': 'Logolistning',
        share: 'Dela',
        share_email: 'Detaljsidan har delats via epost',
        deluxebild: 'Deluxebild',
        share_facebook: 'Detaljsidan har delats via Facebook',
        'topp4-bilder': 'Klick på Topplacering bild',
        'suggest-ad': 'Klick på Söktips',
        sms: 'Klick på knapp för sms',
        'kopieraorg.nummer': 'Organisationsnummret har kopierats',
        kopieraemail: 'Epostadressen har kopierats',
        grunduppgift: 'Grunduppgift',
        direktbokning: 'Klick på direktbokning',
        vardlank: 'Klick på Direktlänk Vård',
        butiklank: 'Klick på Direktlänk Butik',
        menylank: 'Klick på Direktlänk Meny',
        bestallank: 'Klick på Direktlänk Beställ',
        deluxeheader: 'Klick på Deluxeheader',
        'infosida-logo': 'Klick på Infosida logo',
        logo: 'Klick på Logo',
        suggest: 'Klick på Sökförslag',
        soktraff: 'Klick på Sökträff',
        kartuppgift: 'Klick på Kartuppgift',
        '-': '-',
        'result-customers-nearby': '(result-customers-nearby)',
        _clicklist: '(_clicklist)',
        '': '()',
        total: 'Total',
        other: 'Övrigt',
    },

    STATISTICS_FOR: 'Statistik för',
    SEARCH_COMPANIES: 'Sök företag',
    SEARCH_STATISTICS: 'Sökstatistik',
    NO_RESULT_TO_SHOW: 'Inget resultat att visa',
    NO_RESULT_MESSAGE: 'Sökningen gav inget resultat',
    PRINT: 'Skriv ut',
    COMPANY_NAME: 'Företagsnamn',
    SEARCH_BY: 'Sök med',
    ORDER_NUMBER: 'Ordernummer',
    ACTIVE_ORDER: 'Aktiv order',
    EDIT: 'Ändra',
    TYPE: 'Typ',
    CONTACT: 'Kontakt',
    CUSTOMER_CONTACTS: 'Kundkontakter',
    CUSTOMER_CONTACTS_PER: 'Kundkontakter per',
    CUSTOMER_CONTACTS_SHOWN_IN_TABLE: 'Kundkontakter som visas i tabellen',
    COMPANIES_INCLUDED_IN_REPORT: 'företag inkluderas i rapporten',
    HELPTEXT_SELECT_COMPANIES_FOR_REPORT: 'Markera företagen du vill inkludera i rapporten',
    CONTACT_AND_EXPO_STATS: 'Kontakt- & visningsstatistik',
    REPORT_HEADER: 'Rapportrubrik',
    REPORT_SETTINGS: 'Rapportinställningar',
    SHOW_GRAPHS: 'Visa grafer',
    SHOW_PER_COMPANY: 'Visa per företag',
    SHOW_AMOUNTS: 'Visa antal',
    HEADER: 'Rubrik',
    LAST_7_DAYS: 'Senaste sju dagarna',
    WEEK_BEFORE: 'Föregående vecka',
    LINK: 'Länk',
    NATIONWIDE: '(Rikstäckande)',
    HELP: 'Hjälp',
    CLEAR_SEARCH_HISTORY: 'Rensa sökhistorik',
    HISTORY_CLEARED: 'Sökhistorik rensad!',
    USE_ORDER_PERIOD: 'Använd orderdatum',
    OPEN_IN_ORDER_SYSTEM: 'Öppna i ordersystemet',
    AND: 'Och',
    MORE: 'Till',

    HELP_SECTION: {
        HEADER: 'Välkommen till nya statistiksystemet',
        INGRESS: 'Välkommen till det nya statistiksystemet som ska ersätta Census. Initialt finns två rapporter tillgängliga, sökord och företagsrapport',

        SUBHEADER_1: 'Sökord',
        PARAGRAPH_1: 'Används för sökstatistik. Fyll i "Vad" och "Var" och få en sammanställning av sökningar gjorda senaste året på hitta.se samt i hitta.se´s appar för iOS och Android.',

        SUBHEADER_2: 'Företagsrapport',
        PARAGRAPH_2_1: 'Används för kontakt- och exponeringsstatistik. Välj hur du vill söka upp företag i menyn "Sök med" och skriv sedan i det namngivna fältet till höger. Statistik visas för senaste året, väljer du att söka med ordernummer används orderns start- och slutdatum.',
        PARAGRAPH_2_2: 'Efter att du tryck “Sök" och rapporten visas ges även möjlighet att finjustera rapporten i rutan "Rapportinställningar". Här kan du välja vilket data som ska inkluderas, skriva en egen rubrik, samt finjustera vilka företag som inkluderas.',

        SUBHEADER_3: 'Skriv ut / PDF',
        PARAGRAPH_3: 'Rapporterna är anpassade för utskrift och “spara som PDF” via webbläsarens utskriftsfunktion. Dölj sidhuvud och sidfot via webbläsarens skriv ut-inställningar ',

        SUBHEADER_4: 'Något saknas',
        PARAGRAPH_4: 'Upplever du att någon funktionalitet saknas? Statistiksystemet är framtaget för att så enkelt som möjligt ge svar på de frågor om statistik som kan uppkomma vid försäljning. Upplever du att något saknas? Skicka feedback till statistiksystemet@hitta.se.',

        SUBHEADER_5: 'Feedback',
        PARAGRAPH_5: 'Skicka feedback till statistiksystemet@hitta.se',
    },

    COMPANY_SEARCH_LABEL: {
        HID: 'HID, (Vkiid)',
        ORG_NUMBER: 'Organisationsnummer',
        COMPANY_NAME: 'Företagsnamn',
        ORDER_NUMBER: 'Ordernummer',
    },

    COMPANY_SEARCH_PLACEHOLDER: {
        HID: 'jacccqbhi eller hitta.se-länk (separerade med ,)',
        ORG_NUMBER: 'Organisationsnummer',
        COMPANY_NAME: 'Företagsnamn (hid)',
        ORDER_NUMBER: 'Ordernummer',
    },

    COMPANY_REPORT_PAGE_TITLE: 'Företagsrapport | Statistiksystemet',
    SEARCH_STATS_PAGE_TITLE: 'Sökordstatistik | Statistiksystemet',
    COMPANY_ANALYSIS_PAGE_TITLE: 'Företagsanalys | Statistiksystemet',
    LEADS_ANALYSIS_PAGE_TITLE: 'Leadsanalys | Statistiksystemet',
    IMPRESSION_ANALYSIS_PAGE_TITLE: 'Exponeringsanalys | Statistiksystemet',
    LOGIN_PAGE_TITLE: 'Logga in | Statistiksystemet',

    ERROR_MESSAGE_SERVER_ERROR: 'Ett fel inträffade på servern',
    ERROR_MESSAGE_UNAUTHORIZED: 'Du har loggats ut',
    ERROR_MESSAGE_GENERIC: 'Ett fel inträffade',
    ERROR_MESSAGE_DATE_RANGE: 'Längsta tillåtna period är två år.',

    PRODUCT_KEYS: {
        'offer-button-company': 'Offertknapp företag',
        grabover: 'Grabover',
        brf_report: 'Brf-rapport',
        facebook: 'Facebook',
        favorit: 'Favorit',
        foretagsgruppering: 'Företagsgruppering',
        'grafisk-annons': 'Displayplacering',
        hemsidelank: 'Hemsideklick',
        infosida: 'Infosida',
        'infosida-delux': 'Infosida deluxe',
        kopieraadress: 'Kopiera adress',
        kopieratelefonnr: 'Kopiera telefonnr.',
        print: 'Skriv ut',
        route: 'Vägbeskrivning',
        share_sms: 'Dela via SMS',
        show_on_map: 'Visa på karta',
        streetview: 'Gatubild',
        telefonnr: 'Samtal',
        'topp4-logo': 'Topplacering',
        'topp4-annons': 'Topp 4 annons',
        visatelefonnr: 'Visa nummer',
        detail: 'Detalj?',
        email: 'Epost',
        'email-sent': 'E-post skickat',
        livstilskartan: 'Livsstilskartan',
        save: 'Spara',
        textlank: 'Textlänk',
        'logo-listning': 'Logolistning',
        share: 'Dela',
        share_email: 'Dela via epost',
        deluxebild: 'Deluxebild',
        share_facebook: 'Dela via Facebook',
        'topp4-bilder': 'Topplacering bild',
        'suggest-ad': 'Söktips',
        sms: 'SMS',
        'kopieraorg.nummer': 'Kopiera org.nr',
        kopieraemail: 'Kopiera Epost',
        grunduppgift: 'Grunduppgift',
        direktbokning: 'Direktbokning',
        vardlank: 'Direktlänk Vård',
        butiklank: 'Direktlänk Butik',
        menylank: 'Direktlänk Meny',
        bestallank: 'Direktlänk Beställ',
        deluxeheader: 'Deluxeheader',
        'infosida-logo': 'Infosida logo',
        logo: 'Logo',
        suggest: 'Sökförslag',
        soktraff: 'Sökträff',
        kartuppgift: 'Kartuppgift',
        '-': '-',
        'result-customers-nearby': '(result-customers-nearby)',
        _clicklist: '(_clicklist)',
        '': '()',
        total: 'Total',
        other: 'Övrigt',
    },

    PAGE_KEYS: {
        detail: 'Detaljsida',
        list: 'Resultatlista',
        map: 'Karta',
        start: 'Startsida',
        other: 'Övriga sidor',
        favourites: 'Favoriter',
    },

    SOURCE_KEYS: {
        web: 'Web (desktop)',
        mobile: 'Web (mobil)',
        app: 'App',
        ios: 'iOS app',
        android: 'Android app',
        calltracking: 'Samtalsmätning',
    },

    MONTHS: {
        0: 'Januari',
        1: 'Februari',
        2: 'Mars',
        3: 'April',
        4: 'Maj',
        5: 'Juni',
        6: 'Juli',
        7: 'Augusti',
        8: 'September',
        9: 'Oktober',
        10: 'November',
        11: 'December',
    },

    MONTHS_SHORT: {
        0: 'Jan',
        1: 'Feb',
        2: 'Mars',
        3: 'April',
        4: 'Maj',
        5: 'Juni',
        6: 'Juli',
        7: 'Aug',
        8: 'Sep',
        9: 'Okt',
        10: 'Nov',
        11: 'Dec',
    },

    DAYS_SHORT: {
        1: 'mån',
        2: 'tis',
        3: 'ons',
        4: 'tors',
        5: 'fre',
        6: 'lör',
        7: 'sön',
    },
};

export default swedish;
